/**
 * Drizzle query builders + query-key factory for GRADING MODELS (group E).
 * Local-first consumption over PowerSync (stream `academy_org`): org
 * members READ the models to render grades and pick a scale. WRITING is via
 * REST (`/api/academy/:orgId/grading-models`), not local-first.
 */

import {
  and,
  asc,
  desc,
  eq,
  grading_model,
  isNull,
  type PowerSyncDrizzleDB,
} from "@space/powersync";

export const gradingModelsQueryKeys = {
  all: ["academy-grading-models"] as const,
  byOrg: (orgId: string | undefined) => ["academy-grading-models", orgId] as const,
};

/** An org's live models, with the system's first and then by name. */
export function getGradingModelsQuery(db: PowerSyncDrizzleDB, orgId: string) {
  return db
    .select()
    .from(grading_model)
    .where(and(eq(grading_model.organization_id, orgId), isNull(grading_model.deleted_at)))
    .orderBy(desc(grading_model.is_system), asc(grading_model.name));
}

/** A model by id (to resolve a course/cohort's selection). */
export function getGradingModelByIdQuery(db: PowerSyncDrizzleDB, modelId: string) {
  return db.select().from(grading_model).where(eq(grading_model.id, modelId)).limit(1);
}
